import { useCallback } from 'react';
import classNames from 'classnames';
import { ActionMeta } from 'react-select-v5';
import { FieldMetaState } from 'react-final-form';

import { getMetaError } from 'shared/functions/errors';

import styles from './FieldBinaryToggle.module.scss';

type Props = {
  input: { name: string; value: boolean; onChange?: (value: boolean) => void };
  meta?: ActionMeta<any> | FieldMetaState<any>;
  fluid?: boolean;
  labelTrue?: string;
  labelFalse?: string;
};
export const FieldBinaryToggle = ({ input, meta, fluid, labelTrue = 'Yes', labelFalse = 'No' }: Props) => {
  const onTrue = useCallback(() => {
    input.onChange?.(true);
  }, [input]);

  const onFalse = useCallback(() => {
    input.onChange?.(false);
  }, [input]);

  const error = getMetaError(meta);

  const wrapperClass = classNames('btn-group', {
    [styles.fluid]: !!fluid,
  });

  const getButtonClassName = (type: boolean, fluid: boolean) =>
    classNames('btn btn-sm btn-default', {
      active: input.value === type,
      [styles.buttonFluid]: !!fluid,
    });

  return (
    <div data-testid={input.name} key={input.name}>
      <div className={wrapperClass}>
        {[true, false].map((type) => (
          <button
            type="button"
            key={type.toString()}
            className={getButtonClassName(type, fluid)}
            onClick={() => (type === false ? onFalse() : onTrue())}
          >
            {type === false ? labelFalse : labelTrue}
          </button>
        ))}
      </div>

      {error && <div className="errorMsg">{error}</div>}
    </div>
  );
};
